export enum MemberActionType {
  EDIT = "Edit",
  DELETE = "Delete"
}